/**
 * Azuri Diamonds — Global Cart Manager v7.7
 * v7.5: Grade-aware combined display, hide by line key, orphan cleanup,
 *       lock timeout refresh, helper consolidation
 * v7.6: 6-variant upgrade product (3 grades × 2 carat tiers)
 * v7.7: Rev 3 — 30-variant upgrade product (3 grades × 10 carats).
 *       UPGRADE_VARIANTS is reference-only; product.liquid supplies the exact
 *       (grade, carat)-matched variant ID to reconcile() per request.
 *       Sync / reconcile logic unchanged — still grade-aware on opaque strings.
 */
(function () {
  'use strict';

  var UPGRADE_TEXT = 'gemstone quality upgrade';
  var LOCK_DURATION_MS = 8000;
  var SYNC_COOLDOWN_MS = 1000;
  var GRADE_PROP = 'Select Gemstone Quality';
  var GRADE_PROP_LOWER = 'Select gemstone quality';
  var UPGRADE_PROP = '_gemstone_upgrade';
  var PARENT_PROP = '_parent_product';

  var syncTimer = null;
  var syncCooldown = 0;
  var cachedUQ = 0;
  var lastEventCart = null;
  var lockTimeout = null;
  var lastCartData = null;
  var pendingUpgrade = false;

  /* All 30 upgrade variant IDs — reference only; product.liquid picks the right one per request.
     Keys: grade → carat key (below / 1 / 1.5 / 2 / 2.5 / 3 / 3.5 / 4 / 4.5 / 5) */
  var UPGRADE_VARIANTS = {
    'D': {
      'below': 48068438753435, '1':   48355640082587, '1.5': 48389358518427,
      '2':     48389358551195, '2.5': 48389358583963, '3':   48389358616731,
      '3.5':   48389358649499, '4':   48389358682267, '4.5': 48389358715035,
      '5':     48389358747803
    },
    'E-F': {
      'below': 48068438786203, '1':   48355640115355, '1.5': 48389358780571,
      '2':     48389358813339, '2.5': 48389358846107, '3':   48389358878875,
      '3.5':   48389358911643, '4':   48389358944411, '4.5': 48389358977179,
      '5':     48389359009947
    },
    'G-H': {
      'below': 48068438818971, '1':   48355640148123, '1.5': 48389359042715,
      '2':     48389359075483, '2.5': 48389359108251, '3':   48389359141019,
      '3.5':   48389359173787, '4':   48389359206555, '4.5': 48389359239323,
      '5':     48389359272091
    }
  };

  /* ═══ HELPERS ═══ */

  function isUpgradeItem(item) {
    return !!(item && item.properties && item.properties[UPGRADE_PROP]);
  }
  function getParentGrade(item) {
    if (!item || !item.properties) return null;
    return item.properties[GRADE_PROP] || item.properties[GRADE_PROP_LOWER] || null;
  }
  function gradeKey(handle, grade) {
    return handle + '|' + grade;
  }

  try { cachedUQ = parseInt(sessionStorage.getItem('azuri_uq') || '0', 10) || 0; } catch (e) {}
  function saveCache(qty) {
    cachedUQ = qty;
    try { sessionStorage.setItem('azuri_uq', String(qty)); } catch (e) {}
  }
  function countUpgrades(cart) {
    var n = 0;
    if (cart && cart.items) cart.items.forEach(function (i) {
      if (isUpgradeItem(i)) n += i.quantity;
    });
    return n;
  }
  function formatMoney(paise) {
    return 'Rs. ' + (paise / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  /* ═══ CHECKOUT LOCK ═══ */

  var lockCSS = document.createElement('style');
  lockCSS.textContent = [
    'body.azuri-syncing button[name="checkout"] { pointer-events: none !important; opacity: 0.4 !important; cursor: wait !important; }',
    'body.azuri-syncing .buy-buttons a { pointer-events: none !important; opacity: 0.4 !important; cursor: wait !important; }',
    'body.azuri-syncing .additional-checkout-buttons { pointer-events: none !important; opacity: 0.4 !important; }',
    'body.azuri-syncing form[action*="/cart"] button[type="submit"] { pointer-events: none !important; opacity: 0.4 !important; cursor: wait !important; }'
  ].join('\n');
  document.head.appendChild(lockCSS);

  function lockCheckout() {
    document.body.classList.add('azuri-syncing');
    clearTimeout(lockTimeout);
    lockTimeout = setTimeout(unlockCheckout, LOCK_DURATION_MS);
  }
  function unlockCheckout() {
    document.body.classList.remove('azuri-syncing');
    clearTimeout(lockTimeout);
  }

  /* ═══ DOT ═══ */

  function updateDot(cart) {
    if (!cart || !cart.items) return;
    var v = cart.item_count - countUpgrades(cart);
    document.querySelectorAll('.header__cart-count cart-count').forEach(function (el) {
      if (v > 0) el.setAttribute('data-has-items', '');
      else el.removeAttribute('data-has-items');
    });
  }

  /* ═══ COMBINED PRICE DISPLAY (grade-aware) ═══ */

  function getLineItemGrade(el) {
    var items = el.querySelectorAll('li');
    for (var i = 0; i < items.length; i++) {
      var m = items[i].textContent.match(/Select\s+[Gg]emstone\s+[Qq]uality:\s*([A-Za-z0-9\-]+)/);
      if (m) return m[1].trim();
    }
    var m2 = (el.textContent || '').match(/Select\s+[Gg]emstone\s+[Qq]uality:\s*([A-Za-z0-9\-]+)/);
    return m2 ? m2[1].trim() : null;
  }

  function updateLineItemPrices(cart) {
    if (!cart || !cart.items) cart = lastCartData;
    if (!cart || !cart.items) return;
    lastCartData = cart;

    var upgradeUnitPrice = {};
    cart.items.forEach(function (i) {
      if (isUpgradeItem(i)) {
        upgradeUnitPrice[gradeKey(i.properties[PARENT_PROP], i.properties[UPGRADE_PROP])] = i.price;
      }
    });

    if (Object.keys(upgradeUnitPrice).length === 0) return;

    var ringData = {};
    cart.items.forEach(function (i) {
      if (isUpgradeItem(i)) return;
      var g = getParentGrade(i);
      if (!g) return;
      ringData[gradeKey(i.handle, g)] = {
        qty: i.quantity,
        finalLine: i.final_line_price,
        originalLine: i.original_line_price
      };
    });

    document.querySelectorAll('line-item').forEach(function (el) {
      if (el.dataset.gemstoneHidden === 'true') return;

      var link = el.querySelector('a[href*="/products/"]');
      if (!link) return;
      var match = link.getAttribute('href').match(/\/products\/([^?&#/]+)/);
      if (!match) return;
      var handle = match[1];

      var grade = getLineItemGrade(el);
      if (!grade) return;

      var k = gradeKey(handle, grade);
      var addOn = upgradeUnitPrice[k];
      if (!addOn) return;
      var ring = ringData[k];
      if (!ring) return;

      var combinedLinePrice = ring.finalLine + (addOn * ring.qty);
      var combinedOriginalPrice = ring.originalLine + (addOn * ring.qty);

      var saleEl = el.querySelector('sale-price');
      if (saleEl) {
        saleEl.innerHTML = '<span class="sr-only">Sale price</span>' + formatMoney(combinedLinePrice);
      }
      var compareEl = el.querySelector('compare-at-price');
      if (compareEl && !compareEl.hasAttribute('hidden')) {
        compareEl.innerHTML = '<span class="sr-only">Regular price</span>' + formatMoney(combinedOriginalPrice);
      }
    });
  }

  /* ═══ LAYER 1: PATCH ═══ */

  customElements.whenDefined('cart-count').then(function () {
    var CC = customElements.get('cart-count');
    if (!CC) return;
    var desc = Object.getOwnPropertyDescriptor(CC.prototype, 'itemCount');
    if (!desc || !desc.set) return;
    var origSet = desc.set;
    Object.defineProperty(CC.prototype, 'itemCount', {
      get: desc.get,
      set: function (c) { origSet.call(this, cachedUQ > 0 ? Math.max(0, c - cachedUQ) : c); },
      configurable: true, enumerable: true
    });
    console.log('Azuri Cart: Patched');
  });

  /* ═══ LAYER 2: CAPTURE ═══ */

  document.addEventListener('cart:change', function (e) {
    if (!e.detail || !e.detail.cart) return;
    var cart = e.detail.cart;
    if (!cart.items || cart.items.length === undefined) return;

    saveCache(countUpgrades(cart));
    lastEventCart = cart;
    lastCartData = cart;
    updateDot(cart);
    if (cachedUQ > 0) cart.item_count = Math.max(0, cart.item_count - cachedUQ);
  }, true);

  /* ═══ LAYER 3: PAGE LOAD ═══ */

  function verifyCache() {
    var old = cachedUQ;
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      saveCache(countUpgrades(cart));
      lastCartData = cart;
      updateDot(cart);
      updateLineItemPrices(cart);
      if (old !== cachedUQ) {
        document.querySelectorAll('cart-count').forEach(function (el) { el.itemCount = cart.item_count; });
      }
      return cart;
    });
  }
  verifyCache();

  function refreshDrawer() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    setTimeout(function () {
      verifyCache().then(function (cart) { updateLineItemPrices(cart); });
    }, 500);
  }

  /* ═══ BALANCE CHECK (grade-aware) ═══ */

  function isBalanced(cart) {
    var pByGrade = {}, uByGrade = {};
    cart.items.forEach(function (i) {
      if (!i.properties) return;
      if (isUpgradeItem(i)) {
        var uk = gradeKey(i.properties[PARENT_PROP], i.properties[UPGRADE_PROP]);
        uByGrade[uk] = (uByGrade[uk] || 0) + i.quantity;
      } else {
        var pg = getParentGrade(i);
        if (!pg) return;
        var pk = gradeKey(i.handle, pg);
        pByGrade[pk] = (pByGrade[pk] || 0) + i.quantity;
      }
    });
    for (var uk2 in uByGrade) {
      if ((pByGrade[uk2] || 0) !== uByGrade[uk2]) return false;
    }
    for (var pk2 in pByGrade) {
      if ((uByGrade[pk2] || 0) !== pByGrade[pk2]) return false;
    }
    return true;
  }

  /* ═══ SYNC ═══ */

  var retryCount = 0;

  function syncCart() {
    var now = Date.now();
    if (now - syncCooldown < SYNC_COOLDOWN_MS) return;
    syncCooldown = now;
    lockCheckout();

    var cartPromise;
    if (lastEventCart && lastEventCart.items) {
      cartPromise = Promise.resolve(lastEventCart);
      lastEventCart = null;
    } else {
      cartPromise = fetch('/cart.js').then(function (r) { return r.json(); });
    }

    cartPromise.then(function (cart) {
      var parentByGrade = {};
      cart.items.forEach(function (i) {
        if (isUpgradeItem(i)) return;
        var grade = getParentGrade(i);
        if (!grade) return;
        var gk = gradeKey(i.handle, grade);
        parentByGrade[gk] = (parentByGrade[gk] || 0) + i.quantity;
      });

      var upgrades = [];
      cart.items.forEach(function (i) {
        if (!isUpgradeItem(i)) return;
        upgrades.push({
          key: i.key,
          qty: i.quantity,
          parentHandle: i.properties[PARENT_PROP],
          grade: i.properties[UPGRADE_PROP]
        });
      });

      var updates = {}, changed = false;
      upgrades.forEach(function (u) {
        var gk = gradeKey(u.parentHandle, u.grade);
        var target = parentByGrade[gk] || 0;
        if (u.qty !== target) { updates[u.key] = target; changed = true; }
        parentByGrade[gk] = 0;
      });

      if (!changed) {
        retryCount = 0;
        updateLineItemPrices(cart);
        if (!pendingUpgrade) unlockCheckout();
        return;
      }

      console.log('Azuri Cart: Syncing', updates);
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function (r) { return r.json(); }).then(function (updatedCart) {
        saveCache(countUpgrades(updatedCart));
        updateDot(updatedCart);
        lastCartData = updatedCart;
        updateLineItemPrices(updatedCart);
        refreshDrawer();

        setTimeout(function () {
          if (!isBalanced(updatedCart) && retryCount < 3) {
            retryCount++;
            console.log('Azuri Cart: Retry ' + retryCount);
            lockCheckout();
            syncCooldown = 0;
            syncCart();
          } else {
            retryCount = 0;
            if (!pendingUpgrade) unlockCheckout();
          }
        }, 800);
      });

    }).catch(function (err) {
      console.error('Azuri Cart: error', err);
      retryCount = 0;
      unlockCheckout();
    });
  }

  function scheduleSync(delay) {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncCart, delay || 200);
  }

  /* ═══ DOM HIDING ═══ */

  var hideCSS = document.createElement('style');
  hideCSS.textContent = 'line-item[data-gemstone-hidden="true"]{display:none!important}';
  document.head.appendChild(hideCSS);

  function processLineItems() {
    var upgradeKeys = {};
    if (lastCartData && lastCartData.items) {
      lastCartData.items.forEach(function (i) {
        if (isUpgradeItem(i) && i.key) upgradeKeys[i.key] = true;
      });
    }

    document.querySelectorAll('line-item').forEach(function (el) {
      if (el.dataset.gemstoneHidden === 'true') return;

      var qtyInput = el.querySelector('input[data-line-key]');
      if (qtyInput) {
        var key = qtyInput.getAttribute('data-line-key');
        if (key && upgradeKeys[key]) {
          el.dataset.gemstoneHidden = 'true';
          return;
        }
      }

      var t = el.querySelector('.bold, a[href]');
      if (t && t.textContent.trim().toLowerCase().indexOf(UPGRADE_TEXT) >= 0) {
        el.dataset.gemstoneHidden = 'true';
      }
    });

    updateLineItemPrices();
  }

  var hd = null;
  new MutationObserver(function () {
    clearTimeout(hd); hd = setTimeout(processLineItems, 100);
  }).observe(document.body, { childList: true, subtree: true });

  /* ═══ TRIGGERS ═══ */

  document.addEventListener('cart:change', function () { scheduleSync(100); });

  var cartDrawer = document.getElementById('cart-drawer');
  if (cartDrawer) {
    var dd = null;
    new MutationObserver(function () {
      clearTimeout(dd);
      dd = setTimeout(function () { scheduleSync(300); }, 150);
    }).observe(cartDrawer, { childList: true, subtree: true });
  }

  /* ═══ PUBLIC API ═══ */

  window.AzuriCart = {
    addUpgrade: function (variantId, qty, grade, parentHandle) {
      console.log('Azuri Cart: Adding upgrade', { vid: variantId, qty: qty, grade: grade });
      lockCheckout();
      saveCache(cachedUQ + qty);
      var properties = {};
      properties[UPGRADE_PROP] = grade;
      properties[PARENT_PROP] = parentHandle;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: qty, properties: properties }]
        })
      }).then(function (r) { return r.json(); }).then(function (data) {
        console.log('Azuri Cart: Upgrade added', data);
        pendingUpgrade = false;
        syncCooldown = Date.now();
        return verifyCache().then(function () {
          refreshDrawer();
          setTimeout(function () {
            syncCooldown = 0;
            scheduleSync(500);
          }, 1200);
        });
      }).catch(function (err) {
        console.error('Azuri Cart: add failed', err);
        pendingUpgrade = false;
        return verifyCache().then(function () { unlockCheckout(); }, function () { unlockCheckout(); });
      });
    },

    reconcile: function (productHandle, currentGrade, variantIds) {
      if (!currentGrade || !variantIds[currentGrade]) {
        pendingUpgrade = false;
        return Promise.resolve();
      }
      lockCheckout();
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        var pQty = 0, uQty = 0;
        cart.items.forEach(function (i) {
          if (i.handle === productHandle && !isUpgradeItem(i)) {
            if (getParentGrade(i) === currentGrade) pQty += i.quantity;
          }
          if (isUpgradeItem(i) && i.properties[UPGRADE_PROP] === currentGrade && i.properties[PARENT_PROP] === productHandle) {
            uQty += i.quantity;
          }
        });
        console.log('Azuri Cart: Reconcile', { parent: pQty, upgrade: uQty });

        if (pQty > uQty) {
          return window.AzuriCart.addUpgrade(variantIds[currentGrade], pQty - uQty, currentGrade, productHandle);
        } else if (uQty > pQty) {
          console.log('Azuri Cart: Orphan upgrade detected, triggering sync');
          pendingUpgrade = false;
          syncCooldown = 0;
          scheduleSync(200);
        } else {
          pendingUpgrade = false;
          unlockCheckout();
        }
      }).catch(function (err) {
        console.error('Azuri Cart: reconcile error', err);
        pendingUpgrade = false;
        unlockCheckout();
      });
    },

    sync: syncCart,
    recount: verifyCache,
    refreshDrawer: refreshDrawer,
    lockCheckout: lockCheckout,
    unlockCheckout: unlockCheckout,
    setPending: function () { pendingUpgrade = true; }
  };

  console.log('Azuri Cart: Loaded (v7.7)');
})();
